// extracted by mini-css-extract-plugin
export default {"pin":"pin-3942","twinkle":"twinkle-76d5"};